const goToForm1262LoadingStep = require("./goToForm1262LoadingStep");
const submitFormToMarketo = require("../marketo/submitFormToMarketo");
const goToForm1262ConfirmationStep = require("./goToForm1262ConfirmationStep");

/**
 * @param formData {object}
 * @returns {void}
 */
module.exports = async function submitForm1262DataToMarketo(formData) {
    goToForm1262LoadingStep();

    try {
        await submitFormToMarketo(formData);

        goToForm1262ConfirmationStep();
    } catch (e) {
        alert("Could not submit the form! Please try again or contact us!");
    }
};
